<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="6">
					<!-- 품번 -->
					<search-input :label="getMessage_('QWCC000956')" paramKey="partNo" @commInput="setSearchParam" :propData="searchParams.partNo">
					</search-input>
				</el-col>
				<el-col :span="6">
					<!-- 품명 -->
					<search-input
						:label="getMessage_('QWCC000957')"
						paramKey="partName"
						@commInput="setSearchParam"
						:propData="searchParams.partName"
					>
					</search-input>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="6">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cpnyNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.cpnyNm"
						:readonly="isDisabled === 'Y'"
						:iconReadonly="isDisabled === 'Y'"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPqyCpnyPopup"></i></template>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- 팝업추가 영역 -->
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchInput,
		CompPopup
	},
	async created() {
		await this.searchList();
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				await this.getParts_(this.searchParams);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		setSearchParam(param) {
			if (param.key === 'cpnyNm') {
				this.setSearchParam_({ key: 'cpnyCd', value: '' });
			}
			this.setSearchParam_(param);
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			this.$refs.compPopup.open({
				cpnyScn: '10',
				cpnyNm: this.searchParams.cpnyNm
			});
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam_({ key: 'cpnyCd', value: cpnyCd });
			this.setSearchParam_({ key: 'cpnyNm', value: cpnyNm });
		}
	}
};
</script>

<style></style>
